import CompanyModules from '../../factories/modules-service';
import modelReducer from '../../helpers/user-model-reducer';
import AbstractPageBaseController from '../../../core/abstracts/controllers/page-controller';

export default class UserEditCtrl extends AbstractPageBaseController {
    constructor($scope, $injector) {
        super($scope, $injector)

        this.params = this.injector.get('$stateParams');
        this.api = this.injector.get('$http');
        this.state = this.injector.get('$state');
        this.alert = this.injector.get('Alert');
        this.navHelper = this.injector.get('NavHelper');
        this.rootScope = this.injector.get('$rootScope');
        this.translate = this.injector.get('$translate');

        this.currentSettingsTab = 'billing';
        this.availablePrinters = [];
        this.settingsDeposits = {
            invoiceTemplates: [],
            ticketTemplates: [],
            voucherTemplates: [],
            voucherTemplateNumberCirclesByVoucherTemplateId: {},
        };

        this.loading = true;

        this._updateNav();

        Promise.all([
            this.api.get(`users/${this.params.id}`)
                .then(response => {
                    this.originalUser = response.data.data;
                    this.user = modelReducer(response.data.data);
                }),
            this.loadSettingsDependencies()
        ]).then(() => {
            this.loading = false
            this._updateNav();
        });

        this.roles = this.rootScope.company.roles;
        this.modules = CompanyModules.getModules(this.rootScope.company.modules);
    }

    async loadSettingsDependencies() {
        this.settingsDeposits = {
            invoiceTemplates: [],
            ticketTemplates: [],
            voucherTemplates: [],
            voucherTemplateNumberCirclesByVoucherTemplateId: {},
        };

        await Promise.all([
            this.api.get('core/available-printers')
                .then((response) => {
                    this.availablePrinters = response.data.data.map((printer) => {
                        return {
                            value: printer,
                            label: printer
                        }
                    });
                }),
            this.api.post('fp/billing/invoices/templates', {fields: ['title', 'id']})
                .then((response) => {
                    this.settingsDeposits.invoiceTemplates = response.data.data
                }),
            this.api.post('fp/vouchers/templates', {fields: ['title', 'id']})
                .then(async (response) => {
                    this.settingsDeposits.voucherTemplates = response.data.data

                    const subJobsToWaitFor = [];

                    this.settingsDeposits.voucherTemplates.forEach(voucherTemplate => {
                        subJobsToWaitFor.push(
                            this.api.post(`fp/vouchers/templates/${voucherTemplate.id}/number-circles`, {fields: ['title', 'id']})
                                .then(async (response) => {
                                    this.settingsDeposits.voucherTemplateNumberCirclesByVoucherTemplateId[voucherTemplate.id] =
                                        response.data.data.map((numberCircle) => ({
                                            value: numberCircle.id,
                                            label: numberCircle.title
                                    }))
                                })
                        )
                    })

                    return Promise.all(subJobsToWaitFor)
                }),
            this.api.post('fp/tickets/templates', {fields: ['name', 'id']})
                .then((response) => {
                    this.settingsDeposits.ticketTemplates = response.data.data
                }),
        ])
    }

    save(user) {
        this.api.put(`users/${this.params.id}`, user)
            .then(response => {
                if (this.params.store) {
                    this.params.store.dispatch('getData')
                }

                this.alert.success('Success', 'Changes have been saved successful');

                this.cancel();
            }, rejection => {
                this.alert.error(rejection.data.message);
            });
    }

    cancel() {
        this.state.go('app.users.index');
    }

    _updateNav() {
        this.navHelper.setTranslationsParamsForEntry('settings.users.details', {
            name: this.loading ? this.translate.instant('general.verbs.loading_dot') : this.user.full_name
        })
    }

    changeSettingsTab(newTab) {
        this.currentSettingsTab = newTab;
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/users/controllers/pages/edit.js